import React from 'react';

import moment from 'moment';
import { T } from 'react-translator-component';

import { INotifications } from '../../../types/responses/Notifications';
import { AlertIndicatorIcon } from '../../molecules/AlertIndicatorIcon/AlertIndicatorIcon';

const MPT = ['Sem nome', T('Undefined')];

export interface InnerDataFormater {
  chargeBoxId: string;
  about: {
    chargeBoxName: string;
    connectorId: string;
    type: string;
    dateTime: string;
    userName: string;
    transactionId: number;
    errorMessage: string;
    errorCode: string;
  };
}

const innerDataFormater = (notification: INotifications) => {
  return {
    chargeBoxId: notification.chargeBoxId,
    about: {
      chargeBoxName: notification.chargeBoxName,
      connectorId: notification.connectorId,
      type: notification.type,
      dateTime: moment.utc(notification.notificationTimestampDT).local().format('DD/MM/YYYY HH:mm'),
      userName: notification.userName,
      transactionId: notification.transactionId,
      errorMessage: notification.connectorErrorMsg,
      errorCode: notification.connectorErrorCode,
    },
  };
};

const listFormater = (list: INotifications[]) => {
  let cardsList: any = [];
  let innerData: any = [];

  list !== undefined &&
    list.forEach((notification) => {
      cardsList = [
        ...cardsList,
        [
          {
            value: notification.chargeBoxName || T(MPT[1]),
            subValue: notification.chargeBoxId,
            icon: <></>,
            size: '20%',
          },
          { value: notification.addressState || T(MPT[1]), subValue: '', icon: <></>, size: '12%' },
          { value: notification.addressCity || T(MPT[1]), subValue: '', icon: <></>, size: '13%' },
          { value: notification.addressStreet || T(MPT[1]), subValue: '', icon: <></>, size: '30%' },
          {
            value: moment.utc(notification.notificationTimestampDT).local().format('DD/MM/YYYY HH:mm:ss'),
            subValue: '',
            icon: <></>,
            size: '15%',
          },
          { value: '', subValue: '', size: '10%', icon: <AlertIndicatorIcon type={notification.type} /> },
        ],
      ];

      innerData = [...innerData, innerDataFormater(notification)];
    });

  return { cardsList, innerData };
};

export const combiningObjects = (list: INotifications[], header) => {
  return {
    header,
    ...listFormater(list),
  };
};
